import React, { Fragment, useEffect, useState } from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  UncontrolledTooltip,
} from "reactstrap";

// redux toolkit
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { setActivation } from "../../slices/apps/packageSlice";

// data dosyaları
import Question from "../../assets/images/question.png";

const BulkSalePassiveModal = ({ id, isActive }) => {
  const dispatch = useDispatch();

  // states
  const [modal, setModal] = useState(false);

  // states
  const { setActivationLoading } = useSelector((state) => {
    return {
      setActivationLoading: state.package.setActivationLoading,
    };
  }, shallowEqual);

  const setPassive = async () => {
    const data = {
      packageAgencyId: id,
      isActive: !isActive,
    };

    try {
      const resultAction = await dispatch(setActivation(data));

      if (resultAction.meta.requestStatus === "fulfilled") {
        setModal(false);
      }
    } catch (error) {
      console.error("Failed:", error);
    }
  };

  function tog_large(e) {
    if (e) {
      setModal(true);
    } else setModal(false);
  }

  return (
    <Fragment>
      <span
        id={`bulk-sale-passive-tooltipTop-${id}`}
        style={{
          display: "flex",
          cursor: "pointer",
          padding: "3px",
        }}
        onClick={() => tog_large(true)}
      >
        {isActive ? (
          <i
            className="bx bx-no-entry text-dark"
            style={{
              fontSize: "20px",
            }}
          />
        ) : (
          <i
            className="bx bx-check-circle text-dark"
            style={{
              fontSize: "20px",
            }}
          />
        )}
      </span>

      <UncontrolledTooltip
        placement="top"
        target={`bulk-sale-passive-tooltipTop-${id}`}
      >
        {isActive ? "Pasifleştir" : "Aktifleştir"}
      </UncontrolledTooltip>

      <Modal
        size="md"
        isOpen={modal}
        toggle={() => {
          tog_large(false);
        }}
      >
        <ModalHeader
          className="modal-title "
          id="myLargeModalLabel"
          toggle={() => {
            tog_large(false);
          }}
        >
          {isActive ? "Pasifleştir" : "Aktifleştir"}
        </ModalHeader>

        <ModalBody className="text-center text-dark">
          <img
            src={Question}
            alt="SMS Question"
            id="candidate-img"
            className="img-fluid mb-4"
            style={{ height: "80px" }}
          />
          <h4 className="text-dark">
            {isActive ? "Pasifleştirmek" : "Aktifleştirmek"} istediğinize emin
            misiniz?
          </h4>
          <div className="d-flex align-items-center gap-3 mt-5 justify-content-center">
            <Button
              className="btn btn-sm"
              color="primary"
              disabled={setActivationLoading}
              onClick={setPassive}
            >
              Onayla
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </Fragment>
  );
};

export default BulkSalePassiveModal;
